import { regionData, codeToText } from "element-china-area-data";

export default {
    searchRegionByText({ provinceName, cityName, areaName } = row) {
      let find = [];
      const province = regionData.find(e => e.label === provinceName);
      if (province) {
        find.push(province.value);

        const city = province.children.find(e => e.label === cityName);
        if (city) {
          find.push(city.value);

          const area = city.children.find(e => e.label === areaName);
          if (area) {
            find.push(area.value);
          }
        }
      }
      return find.length<3 ?null: find;
    },
    valueByKey(value,array, key = "value",valueKey = "label") {
      const find = array.find(e => {
        if (e[key] === value) {
          return e[valueKey];
        }
      });

      return find ? find[valueKey] : value;
    },
    distributionSubMitNot200(formName, res,this_) {
      if (res.data.code === 202) {
            // this_.$confirm(res.data.message, '提示', {
            //   confirmButtonText: '确定',
            //   cancelButtonText: '取消',
            //   type: 'warning'
            // }).then(() => {
            //   this_.distributionSubMit(formName, true)
            // }).catch(() => {
            //   this_.dialogFormDistribution = false;
            // });
            this_.$prompt(res.data.message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPlaceholder: '请输入备注',
                inputType: 'textarea', // 可选，设置为多行输入
                inputValidator: (value) => {
                  if (!value) {
                    return '备注不能为空';
                  }
                  return true;
                }
              }).then(({ value }) => {
                // 用户输入了备注，点击了“确定”
                this_.distributionSubMit(formName, value); // 把备注传过去
              }).catch(() => {
                // 用户点击“取消”
                this_.dialogFormDistribution = false;
              });
        } else {
          this_.$message.error(res.data.message);
        }
    }
  }